import { UploadOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Flex, Form, Image, Input, notification, Row, Select, Space, Typography, Upload } from 'antd';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import Constant from '../../lib/constant';
import SH_Model from '../../components/SH_Model';
import categoryApi from '../../api/category';
import uploadApi from '../../api/file';

const { Text } = Typography;

const defaultData = {
	createdAt: new Date(),
	image: {},
	names: '',
};

function TV_category_detail(props, ref) {
	const { getProducts, projects } = props;

	const [formInstance, setFormInstance] = useState();
	const [open, setOpen] = useState(false);
	const [form] = Form.useForm();
	const refMode = useRef();

	const [initValue, setInitValue] = useState(defaultData);
	const [api, contextHolder] = notification.useNotification();
	const [fileList, setFileList] = useState([]);
	const [uploading, setUploading] = useState(false);
	const [loading, setLoading] = useState(false);

	const [errors, setErrors] = useState({});
	const propsErrors = {
		names: {
			vi: null,
			en: null,
		},
	};

	const openNotificationWithIcon = (type, message, description) => {
		api[type]({ message, description });
	};

	useImperativeHandle(ref, () => ({
		create: () => {
			setOpen(true);
			refMode.current = Constant.crud.create;
		},
		update: (category) => {
			setInitValue(category);
			setOpen(true);
			refMode.current = Constant.crud.update;
		},
	}));

	useEffect(() => {
		onFormInstanceReady(form);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onFormInstanceReady = (instance) => setFormInstance(instance);

	const validate = (propsValidate, data) => {
		const _data = structuredClone(data || initValue);
		const _errors = structuredClone(propsValidate || propsErrors);

		_errors.names.vi = _data['names']?.['vi']?.length > 0 ? null : 'Dữ liệu không thể để trống';
		_errors.names.en = _data['names']?.['en']?.length > 0 ? null : 'Dữ liệu không thể để trống';

		setErrors(_errors);
		return Object.values(_errors.names);
	};

	const handleSubmit = async () => {
		try {
			const _errorList = validate(propsErrors);
			if (_errorList.filter((x) => x).length === 0) {
				if (refMode.current === Constant.crud.update) {
					setLoading(true);
					const { _id, image, names, projectIds } = initValue;

					await categoryApi.update(_id, {
						image: image?.url ? image : {},
						names,
						projectIds,
					});
					openNotificationWithIcon('success', 'Thành công', 'Thao tác thành công');
					onCancel();
					getProducts();
					setLoading(false);
				} else {
					setLoading(true);
					await categoryApi.create({
						...initValue,
					});
					openNotificationWithIcon('success', 'Thành công', 'Thao tác thành công');
					onCancel();
					getProducts();
					setLoading(false);
				}
			}
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	const onCancel = () => {
		setOpen(false);
		refMode.current = '';
		formInstance?.resetFields();
		setInitValue(defaultData);
		setErrors(propsErrors);
		setFileList([]);
	};

	const handleUpload = async () => {
		setUploading(true);
		await uploadApi.uploadImage(fileList[0]).then((res) => {
			setInitValue((prev) => ({
				...prev,
				image: res.data.data,
			}));
			setUploading(false);
		});
	};

	const prop = {
		maxCount: 1,
		onRemove: (file) => {
			const index = fileList.indexOf(file);
			const newFileList = fileList.slice();
			newFileList.splice(index, 1);
			setFileList(newFileList);
		},
		beforeUpload: (file) => {
			setFileList([file]);
			return false;
		},
		fileList,
	};

	const isCreate = refMode.current === Constant.crud.create;

	return (
		<>
			{contextHolder}

			<SH_Model
				width={620}
				open={open}
				handleSubmit={handleSubmit}
				onCancel={onCancel}
				textOk={isCreate ? 'Tạo mới' : 'Cập nhật'}
				loading={loading}
				title={isCreate ? 'Tạo mới loại sản phẩm' : 'Cập nhật loại sản phẩm'}
			>
				<Form form={form} layout="vertical" requiredMark={false}>
					<Row gutter={12}>
						<Col span={12}>
							<Form.Item label="Tên loại sản phẩm (Tiếng Việt)" required>
								<Input
									placeholder="Nhập tên (VI)"
									value={initValue.names?.vi}
									onChange={(e) =>
										setInitValue((prev) => ({
											...prev,
											names: { ...initValue?.names, vi: e.target.value },
										}))
									}
								/>
								<Text type="danger">{errors?.names?.vi}</Text>
							</Form.Item>
						</Col>

						<Col span={12}>
							<Form.Item label="Tên loại sản phẩm (Tiếng Anh)" required>
								<Input
									placeholder="Enter name (EN)"
									value={initValue.names?.en}
									onChange={(e) =>
										setInitValue((prev) => ({
											...prev,
											names: { ...initValue?.names, en: e.target.value },
										}))
									}
								/>
								<Text type="danger">{errors?.names?.en}</Text>
							</Form.Item>
						</Col>

						<Col span={24}>
							<Form.Item label="Dự án">
								<Select
									mode="multiple"
									defaultValue={[]}
									style={{ width: '100%' }}
									fieldNames={{ label: 'label', value: '_id' }}
									value={initValue.projectIds}
									options={projects}
									onChange={(e) => setInitValue((prev) => ({ ...prev, projectIds: e }))}
									placeholder="Chọn dự án áp dụng"
								/>
							</Form.Item>
						</Col>
					</Row>

					<Divider style={{ margin: '10px 0' }} />

					<Form.Item label="Ảnh đại diện">
						<Space wrap>
							<Upload {...prop} disabled={uploading} maxCount={1}>
								<Button icon={<UploadOutlined />}>Chọn ảnh</Button>
							</Upload>

							<Button type="primary" onClick={handleUpload} disabled={fileList.length === 0} loading={uploading}>
								{uploading ? 'Đang tải' : 'Tải lên'}
							</Button>
						</Space>

						{initValue?.image?.url ? (
							<div style={{ marginTop: 12 }}>
								<Image
									width={180}
									height={120}
									style={{ objectFit: 'cover', borderRadius: 12 }}
									src={initValue.image.url}
									preview
								/>
							</div>
						) : null}
					</Form.Item>
				</Form>
			</SH_Model>
		</>
	);
}

export default forwardRef(TV_category_detail);
